import { login, loginDnb, autoLogin } from '@/api/auth';
import VueCookies from "vue-cookies";

const userStore = {
	namespaced: true,
	state: {
		id: VueCookies.get("id") || "",
		name: VueCookies.get("name") || "",
		clpCd: VueCookies.get("clpCd") || "",
		clpNm: VueCookies.get("clpNm") || "",
		clpTyp: VueCookies.get("clpTyp") || "",
		accessToken: VueCookies.get("accessToken") || "",
		type: VueCookies.get("type") || "",
		lastLoginTime: VueCookies.get("lastLoginTime") || "",
		redirectUrl: null,
	},
	getters: {
		isLogin(state) {
			return state.accessToken !== undefined && state.accessToken !== '';
		},
		isAdmin(state) {
			return state.type === 'BOARD_ADMIN';
		},
		isBank(state) {
			return state.clpTyp === 'TCB_BANK';
		},
		isKrx(state) {
			return state.clpTyp === 'TCB_KRX';
		},
		isVc(state) {
			return state.clpTyp === 'TCB_VC';
		},
		getId(state) {
			return state.id;
		},
		getName(state) {
			return state.name;
		},
		getClpCd(state) {
			return state.clpCd;
		},
		getClpNm(state) {
			return state.clpNm;
		},
		getClpTyp(state) {
			return state.clpTyp;
		},
		getAccessToken(state) {
			return state.accessToken;
		},
		getType(state) {
			return state.type;
		},
		getLastLoginTime(state) {
			return state.lastLoginTime;
		},
		getRedirectUrl(state) {
			 return state.redirectUrl;
		},
		
	},
	mutations: {
		SET_ID(state, userId) {
			state.userId = userId;
		},
		SET_NAME(state, name) {
			state.name = name;
		},
		SET_CLP_CD(state, clpCd) {
			state.clpCd = clpCd;
		},
		SET_CLP_NM(state, clpNm) {
			state.clpNm = clpNm;
		},
		SET_CLP_TYP(state, clpTyp) {
			state.clpTyp = clpTyp;
		},
		SET_ACCESS_TOKEN(state, accessToken) {
			state.accessToken = accessToken;
		},
		SET_TYPE(state, type) {
			state.type = type;
		},
		SET_LAST_LOGIN_TIME(state, lastLoginTime) {
			state.lastLoginTime = lastLoginTime;
		},
		SET_REDIRECT_URL(state, url) {
    		state.redirectUrl = url;
		},
		CLEAR_REDIRECT_URL(state){
			state.redirectUrl = null;
		},
		CLEAR_ALL(state) {
			state.id = "";
			state.name = "";
			state.clpCd = "";
			state.clpNm = "";
			state.clpTyp = "";
			state.accessToken = "";
			state.type = "";
			state.lastLoginTime = "";
		},

	},
	actions: {
		async LOGIN({ commit }, loginUserData) {
			const { data } = await login(loginUserData);

			const date = new Date();
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');

    	const lastLoginTime =  `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

			commit("SET_ID", data.data.id);
			commit("SET_NAME", data.data.name);
			commit("SET_CLP_CD", data.data.clpCd);
			commit("SET_CLP_NM", data.data.clpNm);
			commit("SET_CLP_TYP", data.data.clpTyp);
			commit("SET_ACCESS_TOKEN", data.data.accessToken);
			commit("SET_TYPE", data.data.type);
			commit("SET_LAST_LOGIN_TIME", lastLoginTime);

			VueCookies.set("id", data.data.id);
			VueCookies.set("name", data.data.name);
			VueCookies.set("clpCd", data.data.clpCd);
			VueCookies.set("clpNm", data.data.clpNm);
			VueCookies.set("clpTyp", data.data.clpTyp);
			VueCookies.set("accessToken", data.data.accessToken);
			VueCookies.set("type", data.data.type);
			VueCookies.set("lastLoginTime", lastLoginTime);
		},
		async LOGIN_DNB({ commit }, loginUserData) {
			const { data } = await loginDnb(loginUserData);

			const date = new Date();
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');

    	const lastLoginTime =  `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

			commit("SET_ID", data.data.id);
			commit("SET_NAME", data.data.name);
			commit("SET_CLP_CD", data.data.clpCd);
			commit("SET_CLP_NM", data.data.clpNm);
			commit("SET_CLP_TYP", data.data.clpTyp);
			commit("SET_ACCESS_TOKEN", data.data.accessToken);
			commit("SET_TYPE", data.data.type);
			commit("SET_LAST_LOGIN_TIME", lastLoginTime);

			VueCookies.set("id", data.data.id);
			VueCookies.set("name", data.data.name);
			VueCookies.set("clpCd", data.data.clpCd);
			VueCookies.set("clpNm", data.data.clpNm);
			VueCookies.set("clpTyp", data.data.clpTyp);
			VueCookies.set("accessToken", data.data.accessToken);
			VueCookies.set("type", data.data.type);
			VueCookies.set("lastLoginTime", lastLoginTime);
		},
		async AUTO_LOGIN({ commit }) {
			const { data } = await autoLogin();
			if (data.data == 'null') {
				return;
			}
			const date = new Date();
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');

    	const lastLoginTime =  `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

			commit("SET_ID", data.data.id);
			commit("SET_NAME", data.data.name);
			commit("SET_CLP_CD", data.data.clpCd);
			commit("SET_CLP_NM", data.data.clpNm);
			commit("SET_CLP_TYP", data.data.clpTyp);
			commit("SET_ACCESS_TOKEN", data.data.accessToken);
			commit("SET_TYPE", data.data.type);
			commit("SET_LAST_LOGIN_TIME", lastLoginTime);

			VueCookies.set("id", data.data.id);
			VueCookies.set("name", data.data.name);
			VueCookies.set("clpCd", data.data.clpCd);
			VueCookies.set("clpNm", data.data.clpNm);
			VueCookies.set("clpTyp", data.data.clpTyp);
			VueCookies.set("accessToken", data.data.accessToken);
			VueCookies.set("type", data.data.type);
			VueCookies.set("lastLoginTime", lastLoginTime);
		},
		LOGOUT({ commit }) {
			commit("CLEAR_ALL");
			VueCookies.remove("id");
			VueCookies.remove("name");
			VueCookies.remove("clpCd");
			VueCookies.remove("clpNm");
			VueCookies.remove("clpTyp");
			VueCookies.remove("accessToken");
			VueCookies.remove("type");
			VueCookies.remove("lastLoginTime");
		},
		REFRESH_USER({ commit }, data) {
			commit("SET_ACCESS_TOKEN", data.accessToken);
			VueCookies.set("accessToken", data.accessToken);
		},
	},
};

export default userStore;
